import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, KOZIKAZA_API_OPTIONS, createSubResourceObservable, KazaService, UserService } from '@adeo/ngx-kozikaza-api';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { MediaService } from '@adeo/ngx-kozikaza-api/media';

var LandingSubResource;
(function (LandingSubResource) {
    LandingSubResource.LandingMedias = 'landingMedias';
})(LandingSubResource || (LandingSubResource = {}));

var LandingAttributeSubResource;
(function (LandingAttributeSubResource) {
    LandingAttributeSubResource.Values = 'values';
})(LandingAttributeSubResource || (LandingAttributeSubResource = {}));

var LandingMediaSubResource;
(function (LandingMediaSubResource) {
    LandingMediaSubResource.AttributesValues = 'attributeValues';
    LandingMediaSubResource.Media = 'media';
    LandingMediaSubResource.Kaza = 'kaza';
})(LandingMediaSubResource || (LandingMediaSubResource = {}));

var LandingMediaProcessedDateSubResource;
(function (LandingMediaProcessedDateSubResource) {
    LandingMediaProcessedDateSubResource.Author = 'author';
})(LandingMediaProcessedDateSubResource || (LandingMediaProcessedDateSubResource = {}));

var LandingMediaSelectedSubResource;
(function (LandingMediaSelectedSubResource) {
    LandingMediaSelectedSubResource.Media = 'media';
})(LandingMediaSelectedSubResource || (LandingMediaSelectedSubResource = {}));

var LandingSeoSubResource;
(function (LandingSeoSubResource) {
    LandingSeoSubResource.Landing = 'landing';
})(LandingSeoSubResource || (LandingSeoSubResource = {}));

class LandingAttributeValueService extends BaseService {
    platformId;
    injector;
    static endpoint = '/landing_attribute_values';
    static endpointSuffix = '/values';
    static endpointLandingAttributeSuffix = '/attribute_values';
    static endpointLandingAttributeByPathSuffix = '/by_path';
    getWebServiceName() {
        return 'LandingAttributeValueWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getLandingAttributeValues(subResources, options) {
        return this.getResources(LandingAttributeValueService.endpoint, subResources, options);
    }
    /*    getLandingAttributeValuesNavigator(
            subResources?: LandingAttributeValueSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingAttributeValue>> {
            return this.getLandingAttributeValues(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLandingAttributeValue(landingAttributeValue, subResources, options) {
        return this.getResource(typeof landingAttributeValue === 'string' ? landingAttributeValue : landingAttributeValue['@id'], subResources, options);
    }
    postLandingAttributeValues(landingAttributeValue, options) {
        return this.post(LandingAttributeValueService.endpoint, landingAttributeValue, options);
    }
    putLandingAttributeValue(landingAttributeValue, options) {
        return this.updateResource(typeof landingAttributeValue === 'string' ? landingAttributeValue : landingAttributeValue['@id'], landingAttributeValue, options);
    }
    deleteLandingAttributeValue(landingAttributeValue, options) {
        return this.delete(typeof landingAttributeValue === 'string' ? landingAttributeValue : landingAttributeValue['@id'], options);
    }
    getLandingAttributeValuesByLandingAttribute(landingAttribute, subResources, options) {
        return this.getResources(`${typeof landingAttribute === 'string' ?
            landingAttribute :
            landingAttribute['@id']}${LandingAttributeValueService.endpointSuffix}`, subResources, options);
    }
    /*    getLandingAttributeValuesByLandingAttributeNavigator(
            landingAttribute: Partial<LandingAttribute> | string,
            subResources?: LandingAttributeValueSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingAttributeValue>> {
            return this.getLandingAttributeValuesByLandingAttribute(landingAttribute, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    getLandingAttributeValuesByLandingAndLandingAttribute(landing, landingAttribute, subResources, options) {
        return this.getResources(`${typeof landing === 'string' ? landing : landing['@id']}
            ${typeof landingAttribute === 'string' ? landingAttribute :
            landingAttribute['@id'].replace('landing_', '')}
                ${LandingAttributeValueService.endpointSuffix}`, subResources, options);
    }
    /*    getLandingAttributeValuesByLandingAndLandingAttributeNavigator(
            landing: Partial<Landing> | string,
            landingAttribute: Partial<LandingAttribute> | string,
            subResources?: LandingAttributeValueSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingAttributeValue>> {
            return this.getLandingAttributeValuesByLandingAndLandingAttribute(landing, landingAttribute, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    getLandingAttributeValuesByLandingMedia(landingMedia, subResources, options) {
        return this.getResources(`${typeof landingMedia === 'string' ?
            landingMedia :
            landingMedia['@id']}${LandingAttributeValueService.endpointLandingAttributeSuffix}`, subResources, options);
    }
    /*    getLandingAttributeValuesByLandingMediaNavigator(
            landingMedia: Partial<LandingMedia> | string,
            subResources?: LandingAttributeValueSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingAttributeValue>> {
            return this.getLandingAttributeValuesByLandingMedia(landingMedia, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    landingCheckPath(landingSlug, path) {
        const options = {
            query: new HttpParams({ fromObject: { landing: landingSlug, path } })
        };
        return this.getNoHydraMember(`${LandingAttributeValueService.endpoint}${LandingAttributeValueService.endpointLandingAttributeByPathSuffix}`, options);
    }
    resourceMap(resource) {
        for (const dateField of ['createdAt']) {
            resource[dateField] = resource[dateField] ? new Date(resource[dateField]) : resource[dateField];
        }
        return super.resourceMap(resource);
    }
    getSubResourceObservable(landingAttributeValue, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            // case LandingAttributeValueSubResource.LandingAttribute:
            //     return undefined;
            // case LandingAttributeValueSubResource.LandingMedia:
            //     return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingAttributeValueService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingAttributeValueService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingAttributeValueService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class LandingMediaService extends BaseService {
    platformId;
    injector;
    static endpoint = '/landing_media';
    static endpointLandingMediasSuffix = '/medias';
    getWebServiceName() {
        return 'LandingMediaWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getLandingMedias(subResources, options) {
        return this.getResources(LandingMediaService.endpoint, subResources, options);
    }
    /*    getLandingMediasNavigator(
            subResources?: LandingMediaSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingMedia>> {
            return this.getLandingMedias(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLandingMedia(landingMedia, subResources, options) {
        return this.getResource(typeof landingMedia === 'string' ? landingMedia : landingMedia['@id'], subResources, options);
    }
    postLandingMedias(landingMedia, options) {
        return this.post(LandingMediaService.endpoint, landingMedia, options);
    }
    putLandingMedia(landingMedia, options) {
        return this.updateResource(typeof landingMedia === 'string' ? landingMedia : landingMedia['@id'], landingMedia, options);
    }
    deleteLandingMedia(landingMedia, options) {
        return this.delete(typeof landingMedia === 'string' ? landingMedia : landingMedia['@id'], options);
    }
    getLandingMediasByLanding(landing, subResources, options) {
        return this.getResources(`${typeof landing === 'string' ? landing : landing['@id']}${LandingMediaService.endpointLandingMediasSuffix}`, subResources, options);
    }
    /*    getLandingMediasByLandingNavigator(
            landing: Partial<Landing> | string,
            subResources?: LandingMediaSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingMedia>> {
            return this.getLandingMediasByLanding(landing, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    resourceMap(resource) {
        for (const dateField of ['createdAt']) {
            resource[dateField] = resource[dateField] ? new Date(resource[dateField]) : resource[dateField];
        }
        return super.resourceMap(resource);
    }
    getSubResourceObservable(landingMedia, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case LandingMediaSubResource.Media:
                if (landingMedia.media) {
                    return createSubResourceObservable(this.injector.get(MediaService).getMedia(landingMedia.media, subResourceRequest[1], options), options)
                        .pipe(map(media => {
                        landingMedia.media = media;
                        return landingMedia;
                    }));
                }
                return undefined;
            case LandingMediaSubResource.AttributesValues:
                return createSubResourceObservable(this.injector.get(LandingAttributeValueService).getLandingAttributeValuesByLandingMedia(landingMedia, subResourceRequest[1], options), options)
                    .pipe(map(attributeValues => {
                    landingMedia.attributeValues = attributeValues && attributeValues['hydra:member'] ?
                        attributeValues['hydra:member'] : attributeValues;
                    return landingMedia;
                }));
                return undefined;
            case LandingMediaSubResource.Kaza:
                if (landingMedia.kaza) {
                    return createSubResourceObservable(this.injector.get(KazaService).getKaza(landingMedia.kaza, subResourceRequest[1], options), options)
                        .pipe(map(kaza => {
                        landingMedia.kaza = kaza;
                        return landingMedia;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

const landingEndPoint = {
    endpoint: '/landings',
    endpointByKey: '/landings',
    endpointMediasSuffix: '/medias',
};

class LandingService extends BaseService {
    platformId;
    injector;
    static endpoint = landingEndPoint.endpoint;
    static endpointByKey = landingEndPoint.endpointByKey;
    static endpointMediasSuffix = landingEndPoint.endpointMediasSuffix;
    getWebServiceName() {
        return 'LandingWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postLandings(landing, options) {
        return this.post(LandingService.endpoint, landing, options);
    }
    getLandings(subResources, options) {
        return this.getResources(LandingService.endpoint, subResources, options);
    }
    /*    getLandingsNavigator(
            subResources?: LandingSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<Landing>> {
            return this.getLandings(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLanding(landing, subResources, options) {
        return this.getResource(typeof landing === 'string' ? landing : landing['@id'], subResources, options);
    }
    getLandingByKey(landing, subResources, options) {
        return this.getResource(`${LandingService.endpointByKey}${typeof landing === 'string' ? ('/' + landing) : landing.key}`, subResources, options);
    }
    putLanding(landing, options) {
        return this.updateResource(typeof landing === 'string' ? landing : landing['@id'], landing, options);
    }
    deleteLanding(landing, options) {
        return this.delete(typeof landing === 'string' ? landing : landing['@id'], options);
    }
    getSubResourceObservable(landing, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case LandingSubResource.LandingMedias:
                return createSubResourceObservable(this.injector.get(LandingMediaService).getLandingMediasByLanding(landing, subResourceRequest[1], options), options)
                    .pipe(map(medias => {
                    landing.landingMedia = medias && medias['hydra:member'] ? medias['hydra:member'] : medias;
                    return landing;
                }));
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class LandingAttributeService extends BaseService {
    platformId;
    injector;
    static endpoint = '/landing_attributes';
    static endpointLandingSuffix = '/attributes';
    getWebServiceName() {
        return 'LandingAttributeWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getLandingAttributes(subResources, options) {
        return this.getResources(LandingAttributeService.endpoint, subResources, options);
    }
    /*    getLandingAttributesNavigator(
            subResources?: LandingAttributeSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingAttribute>> {
            return this.getLandingAttributes(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLandingAttribute(landingAttribute, subResources, options) {
        return this.getResource(typeof landingAttribute === 'string' ? landingAttribute : landingAttribute['@id'], subResources, options);
    }
    postLandingAttributes(landingAttribute, options) {
        return this.post(LandingAttributeService.endpoint, landingAttribute, options);
    }
    putLandingAttribute(landingAttribute, options) {
        return this.updateResource(typeof landingAttribute === 'string' ? landingAttribute : landingAttribute['@id'], landingAttribute, options);
    }
    deleteLandingAttribute(landingAttribute, options) {
        return this.delete(typeof landingAttribute === 'string' ? landingAttribute : landingAttribute['@id'], options);
    }
    getLandingAttributeByLanding(landing, subResources, options) {
        return this.getResources(`${typeof landing === 'string' ? landing : landing['@id']}${LandingAttributeService.endpointLandingSuffix}`, subResources, options);
    }
    resourceMap(resource) {
        for (const dateField of ['createdAt']) {
            resource[dateField] = resource[dateField] ? new Date(resource[dateField]) : resource[dateField];
        }
        return super.resourceMap(resource);
    }
    getSubResourceObservable(landingAttribute, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case LandingAttributeSubResource.Values:
                return createSubResourceObservable(this.injector.get(LandingAttributeValueService).getLandingAttributeValuesByLandingAttribute(landingAttribute, subResourceRequest[1], options), options)
                    .pipe(map(values => {
                    landingAttribute.values = values && values['hydra:member'] ? values['hydra:member'] : values;
                    return landingAttribute;
                }));
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingAttributeService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingAttributeService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingAttributeService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class LandingLinkService extends BaseService {
    platformId;
    static endpoint = '/landing_links';
    static endpointLandingSeoLinksSuffix = '/links';
    static endpointLandingLinksSuffix = '/landing_links';
    getWebServiceName() {
        return 'LandingLinkWebService';
    }
    constructor(options, httpClient, platformId, cache, logger) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
    }
    getLandingLinks(subResources, options) {
        return this.getResources(LandingLinkService.endpoint, subResources, options);
    }
    /*    getLandingLinksNavigator(
            subResources?: LandingLinkSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingLink>> {
            return this.getLandingLinks(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLandingLink(landingLink, subResources, options) {
        return this.getResource(typeof landingLink === 'string' ? landingLink : landingLink['@id'], subResources, options);
    }
    postLandingLinks(landingLink, options) {
        return this.post(LandingLinkService.endpoint, landingLink, options);
    }
    putLandingLink(landingLink, options) {
        return this.updateResource(typeof landingLink === 'string' ? landingLink : landingLink['@id'], landingLink, options);
    }
    deleteLandingLink(landingLink, options) {
        return this.delete(typeof landingLink === 'string' ? landingLink : landingLink['@id'], options);
    }
    getLandingLinksByLandingSeo(landing, subResources, options) {
        return this.getResources(`${typeof landing === 'string' ? landing : landing['@id']}${LandingLinkService.endpointLandingSeoLinksSuffix}`, subResources, options);
    }
    getLandingLinksByLanding(landing, subResources, options) {
        return this.getResources(`${typeof landing === 'string' ? landing : landing['@id']}${LandingLinkService.endpointLandingLinksSuffix}`, subResources, options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingLinkService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingLinkService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingLinkService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }]; } });

class LandingMediaSelectedService extends BaseService {
    platformId;
    injector;
    static endpoint = '/landing_media_selecteds';
    getWebServiceName() {
        return 'LandingMediaSelectedWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getLandingMediaSelecteds(subResources, options) {
        return this.getResources(LandingMediaSelectedService.endpoint, subResources, options);
    }
    /*    getLandingMediaSelectedsNavigator(
            subResources?: LandingMediaSelectedSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingMediaSelected>> {
            return this.getLandingMediaSelecteds(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLandingMediaSelected(landingMediaSelected, subResources, options) {
        return this.getResource(typeof landingMediaSelected === 'string' ? landingMediaSelected : landingMediaSelected['@id'], subResources, options);
    }
    postLandingMediaSelecteds(landingMediaSelected, options) {
        return this.post(LandingMediaSelectedService.endpoint, landingMediaSelected, options);
    }
    putLandingMediaSelected(landingMediaSelected, options) {
        return this.updateResource(typeof landingMediaSelected === 'string' ? landingMediaSelected : landingMediaSelected['@id'], landingMediaSelected, options);
    }
    deleteLandingMediaSelected(landingMediaSelected, options) {
        return this.delete(typeof landingMediaSelected === 'string' ? landingMediaSelected : landingMediaSelected['@id'], options);
    }
    resourceMap(resource) {
        for (const dateField of ['createdAt']) {
            resource[dateField] = resource[dateField] ? new Date(resource[dateField]) : resource[dateField];
        }
        return super.resourceMap(resource);
    }
    getSubResourceObservable(landingMediaSelected, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case LandingMediaSelectedSubResource.Media:
                if (landingMediaSelected.media) {
                    return createSubResourceObservable(this.injector.get(MediaService).getMedia(landingMediaSelected.media, subResourceRequest[1], options), options)
                        .pipe(map(media => {
                        landingMediaSelected.media = media;
                        return landingMediaSelected;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaSelectedService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaSelectedService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaSelectedService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class LandingMediaProcessedDateService extends BaseService {
    platformId;
    injector;
    static endpoint = '/landing_media_processed_dates';
    getWebServiceName() {
        return 'LandingMediaProcessedDateWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getLandingMediaProcessedDates(subResources, options) {
        return this.getResources(LandingMediaProcessedDateService.endpoint, subResources, options);
    }
    /*    getLandingMediaProcessedDatesNavigator(
            subResources?: LandingMediaProcessedDateSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingMediaProcessedDate>> {
            return this.getLandingMediaProcessedDates(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLandingMediaProcessedDate(landingMediaProcessedDate, subResources, options) {
        return this.getResource(typeof landingMediaProcessedDate === 'string' ? landingMediaProcessedDate : landingMediaProcessedDate['@id'], subResources, options);
    }
    postLandingMediaProcessedDates(landingMediaProcessedDate, options) {
        return this.post(LandingMediaProcessedDateService.endpoint, landingMediaProcessedDate, options);
    }
    putLandingMediaProcessedDate(landingMediaProcessedDate, options) {
        return this.updateResource(typeof landingMediaProcessedDate === 'string' ? landingMediaProcessedDate : landingMediaProcessedDate['@id'], landingMediaProcessedDate, options);
    }
    deleteLandingMediaProcessedDate(landingMediaProcessedDate, options) {
        return this.delete(typeof landingMediaProcessedDate === 'string' ? landingMediaProcessedDate : landingMediaProcessedDate['@id'], options);
    }
    resourceMap(resource) {
        for (const dateField of ['createdAt']) {
            resource[dateField] = resource[dateField] ? new Date(resource[dateField]) : resource[dateField];
        }
        return super.resourceMap(resource);
    }
    getSubResourceObservable(landingMediaProcessedDate, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case LandingMediaProcessedDateSubResource.Author:
                if (landingMediaProcessedDate.author) {
                    return createSubResourceObservable(this.injector.get(UserService).getUser(landingMediaProcessedDate.author, subResourceRequest[1], options), options)
                        .pipe(map(author => {
                        landingMediaProcessedDate.author = author;
                        return landingMediaProcessedDate;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaProcessedDateService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaProcessedDateService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingMediaProcessedDateService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class LandingSeoService extends BaseService {
    platformId;
    injector;
    static endpoint = '/landing_seos';
    static endpointLandingSeoByPathSuffix = '/by_path';
    getWebServiceName() {
        return 'LandingSeoWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getLandingSeos(subResources, options) {
        return this.getResources(LandingSeoService.endpoint, subResources, options);
    }
    /*    getLandingSeosNavigator(
            subResources?: LandingSeoSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<LandingSeo>> {
            return this.getLandingSeos(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getLandingSeo(landingSeo, subResources, options) {
        return this.getResource(typeof landingSeo === 'string' ? landingSeo : landingSeo['@id'], subResources, options);
    }
    postLandingSeos(landingSeo, options) {
        return this.post(LandingSeoService.endpoint, landingSeo, options);
    }
    putLandingSeo(landingSeo, options) {
        return this.updateResource(typeof landingSeo === 'string' ? landingSeo : landingSeo['@id'], landingSeo, options);
    }
    deleteLandingSeo(landingSeo, options) {
        return this.delete(typeof landingSeo === 'string' ? landingSeo : landingSeo['@id'], options);
    }
    landingSeoByPath(landingSlug, path) {
        const options = {
            query: new HttpParams({ fromObject: { landing: landingSlug, path } })
        };
        return this.getNoHydraMember(`${LandingSeoService.endpoint}${LandingSeoService.endpointLandingSeoByPathSuffix}`, options);
    }
    resourceMap(resource) {
        for (const dateField of ['createdAt']) {
            resource[dateField] = resource[dateField] ? new Date(resource[dateField]) : resource[dateField];
        }
        return super.resourceMap(resource);
    }
    getSubResourceObservable(landingSeo, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case LandingSeoSubResource.Landing:
                if (landingSeo.landing) {
                    return createSubResourceObservable(this.injector.get(LandingService).getLanding(landingSeo.landing, subResourceRequest[1], options), options)
                        .pipe(map(landing => {
                        landingSeo.landing = landing;
                        return landingSeo;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingSeoService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingSeoService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingSeoService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

// import { MediaApiModule } from '../media';
const WEB_SERVICES = [
    LandingService,
    LandingAttributeService,
    LandingAttributeValueService,
    LandingLinkService,
    LandingMediaService,
    LandingMediaProcessedDateService,
    LandingMediaSelectedService,
    LandingSeoService,
];
class LandingApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: LandingApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: LandingApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                    // TODO : vérifier que nécessaire
                    // MediaApiModule,
                    ],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LandingApiModule, LandingAttributeService, LandingAttributeSubResource, LandingAttributeValueService, LandingLinkService, LandingMediaProcessedDateService, LandingMediaProcessedDateSubResource, LandingMediaSelectedService, LandingMediaSelectedSubResource, LandingMediaService, LandingMediaSubResource, LandingSeoService, LandingSeoSubResource, LandingService, LandingSubResource };
